//List of user-agent strings for mobile devices
const mobileListHeader = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile|WPDesktop/i

// Element IDs of above-the-fold CTAs; sticky headers stay hidden while any of them is in view
const STICKY_HEADER_CTA_VIEWPORT_IDS = Object.freeze([
  'hero-banner-content-cta',
  'heroPrimaryBtnContent',
  'apply-url',
  'title-image',
  'hero-consumer-concept-cta',
  'hero-slider-cta',
  'Continue_Lead_CTA',
  'link-button_PromotingFinancialHealthAndAdvocacy',
  'keyTakeaways',
  'table-of-contents',
  'learn-how-it-works-facts-page-cta',
  'link-heroPrimaryButton',
])

export { mobileListHeader, STICKY_HEADER_CTA_VIEWPORT_IDS }
